// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App'
import routes from './router' //路由数据
import ElementUI from 'element-ui'
import axios from 'axios' // 处理http请求

import store from './store' // 状态管理
// import 'element-ui/lib/theme-default/index.css'

import 'element-ui/lib/theme-chalk/index.css'
import moment from 'moment' //时间过滤器 
import 'moment/locale/zh-cn'
Vue.prototype.moment = moment;
import '../static/js/time.js';

import VueVideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
Vue.use(VueVideoPlayer)

// import {
//   Divider,
// } from 'element-ui';

// Vue.use(Divider);

import Videojs from 'video.js'
import 'video.js/dist/video-js.css'
//geturl
import geturlpara from '../static/js/geturlpara.js';
Vue.prototype.$geturlpara = geturlpara
//验证
var VueValidator = require("vue-validator");
Vue.use(VueValidator);
require('./assets/common.scss');
import Mint from 'mint-ui'
import {
  Cell,
  Popup,
  Field,
  Button,
  Swipe,
  SwipeItem
} from 'mint-ui';
Vue.component(Cell.name, Cell);
Vue.component(Popup.name, Popup);
Vue.component(Field.name, Field);
Vue.component(Button.name, Button);
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
import 'mint-ui/lib/style.css' //MintUI

// import VIscroll from 'viscroll';//滚动
Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.prototype.$video = Videojs


const requireComponent = require.context('./components/public', false, /.vue$/);
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName);
  const componentName = fileName.replace(/^.\//, '').replace(/.vue/, '');
  Vue.component(componentName, componentConfig.default || componentConfig)
})
axios.defaults.baseURL = window.IPConfig.baseIP;
// axios.defaults.baseURL = process.env.BASE_API
//post请求 默认加报头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.config.productionTip = false
// export路由 
export const router = new VueRouter({
  routes
  // mode: 'hash', //可选参数 hash history
  // linkActiveClass: 'active' // 选中界面添加active
});
axios.interceptors.request.use(

  // async
  (config) => {
    if (localStorage.getItem('tokendata')) {
      let Storagetoken = JSON.parse(localStorage.getItem('tokendata')).token;
      if (Storagetoken) { // 判断是否存在token，如果存在的话，则每个http header都加上token
        config.headers.Authorization = 'BasicAuth' + " " + Storagetoken;
      }

    }

    // config.url = baseURL22 + config.url

    return config;

  },
  err => {
    return Promise.reject(err);
  });

// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     let auth = JSON.parse(localStorage.getItem('auth'));
//     if (!auth) {
//       next({
//         path: '/login',
//         query: {
//           redirect: to.fullPath
//         }
//       });
//     }
//   }
//   next();
// });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  Mint,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js